import axios from 'axios';
import qs from 'qs';

export default {
  namespaced: true,

  state() {
    return {
      list: [],
      saved: true,
      loaded: false,
      has_changes: false
    };
  },

  mutations: {
    clear: state => {
      state.list = [];
      state.saved = true;
      state.loaded = false;
    },

    add_item: (state, obj) => {
      state.list.push(new Test(obj));
    },

    set_loaded: (state, v) => {
      state.loaded = v;
    },

    set_saved: (state, v) => {
      state.saved = v;
    },

    set_has_changes: (state, v) => {
      state.has_changes = v;
    }
  },
  actions: {
    async load({ commit }, vacancyId) {
      return await axios
        .get(`/v3/tests/vacancy`, {
          params: {
            with: ['questions', 'questions.answers', 'questions.media', 'questions.variables'],
            filter: { vacancy_id: vacancyId }
          },
          paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'brackets' });
          }
        })
        .then(r => {
          commit('clear');
          commit('add_item', r.data._embedded.vacancy_tests[0]);
          commit('set_loaded', true);

          return r.data._embedded.vacancy_tests[0];
        });
    },

    async save({ state }, data) {
      data.id = state.list[0].id;

      return await axios.put('/1.0/tests', { tests: [data] }).then(r => {
        return r;
      });
    },

    async save_all({ state }, data) {
      return await axios.patch(`/v3/tests/vacancy/${state.list[0].id}`, data);
    }
  },

  getters: {
    list: state => state.list,
    saved: state => state.saved,
    loaded: state => state.loaded,
    has_changes: state => state.has_changes
  }
};

class Test {
  constructor(data) {
    let item = data || {};
    this.id = item.id;
    this.name = item.name || '';
    this.description = item.description || '';
    this.page_view = item.page_view || 'single';
    this.is_active = item.is_active || false;
    this.is_question_shuffle = item.is_question_shuffle || false;
    this.is_answer_paste_disabled = item.is_answer_paste_disabled || true;
    this.question_limit = item.question_limit || 0;
    this.time_limit = item.time_limit || 0;
    this.time_limit_enabled = item.time_limit_enabled || false;
    this.is_dropout_enabled = item.is_dropout_enabled || false;
    this.calculate_test_status = item.calculate_test_status || false;
    this.required_score = item.required_score || 0;
  }
}
